// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_ActivityLogEntityType.proto

export enum ENUM_ActivityLogEntityType {
  ACTIVITY_LOG_ENTITY_TYPE_UNSPECIFIED = 'ACTIVITY_LOG_ENTITY_TYPE_UNSPECIFIED',
  ACTIVITY_LOG_ENTITY_TYPE_PROPERTY = 'ACTIVITY_LOG_ENTITY_TYPE_PROPERTY',
  ACTIVITY_LOG_ENTITY_TYPE_PROPERTY_VALUE = 'ACTIVITY_LOG_ENTITY_TYPE_PROPERTY_VALUE',
  ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE = 'ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE',
  ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_PART = 'ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_PART',
  ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_PART_OVERPAYMENT = 'ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_PART_OVERPAYMENT',
  ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_PART_UNDERPAYMENT = 'ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_PART_UNDERPAYMENT',
  ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_COMPARISON_SETTINGS = 'ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_COMPARISON_SETTINGS',
  ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_CASE = 'ACTIVITY_LOG_ENTITY_TYPE_MORTGAGE_CASE',
  ACTIVITY_LOG_ENTITY_TYPE_HELP_CASE = 'ACTIVITY_LOG_ENTITY_TYPE_HELP_CASE',
  ACTIVITY_LOG_ENTITY_TYPE_SMART_SEARCH_CASE = 'ACTIVITY_LOG_ENTITY_TYPE_SMART_SEARCH_CASE',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
